import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import Cookies from "js-cookie";
import axios from "axios";
import { Tab, Tabs, Typography } from "@material-ui/core";
import { IoSettingsOutline } from "react-icons/io5";
import { ApiDataTable } from "../DiamondFeedNew/ApiDataTable/APIDataTable";
import { SwalWarn } from "../Popup";
import { OrderHistoryDetail } from "../DiamondFeedNew/OrderHistory/OrderHistoryDetail";

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

export const WooCommerceRulePage = (props) => {
    const [tab, setTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };

    const history = useHistory();
    const [currencyvalue, setCurrencyValue] = useState("");
    const [supplieron, setSupplierOn] = useState(null);

    const [swalopen, setSwalOpen] = useState({
        open: false,
        message: "",
        okFunction: null,
    });

    useEffect(() => {
        setCurrencyValue(props.customeriframeorapi.api_currency);
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/fetch-supplier-step`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: {
                api_id: props.customeriframeorapi.api_id,
            },
        })
            .then((supreq) => {
                if (supreq && supreq.data) {
                    if (supreq.data !== "Please Turn On Suppliers") {
                        setSupplierOn(supreq.data);
                    }
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            });
    }, [props.customerapi, props.customeriframeorapi]);

    return (
        <div className="card shadow-none card-custom">
            <div className="card-header">
                <h3 className="card-title">WooCommerce Plugin Dashboard</h3>
                <div className="card-toolbar d-flex align-items-center">
                    <div className="card-toolbar d-flex align-items-center">
                        <button
                            className="btn btn-text-dark btn-hover-light-dark"
                            onClick={() =>
                                history.push({
                                    pathname: "/woocommerce-plugin-setting",
                                })
                            }
                        >
                            <IoSettingsOutline className="mr-2" />
                            {
                                props.language
                                    .DIAMOND_FEED_WOOCOMMERCE_APP_SETTING
                            }
                        </button>
                    </div>
                </div>
            </div>
            <div className={`col-12 mb-3 border-bottom`}>
                <Tabs
                    variant="scrollable"
                    value={tab}
                    onChange={handleTabChange}
                >
                    <Tab label="Mark-up rules Manager" />
                    <Tab label="Order History" />
                </Tabs>
            </div>
            {tab === 0 ? (
                <ApiDataTable
                    userinfo={props.userinfo}
                    language={props.language}
                    customerapi={props.customerapi}
                    setUpdateData={props.setUpdateData}
                    updatedata={props.updatedata}
                    currencyvalue={currencyvalue}
                    supplieron={supplieron}
                    loader={props.loader}
                    setCustomerAPI={props.setCustomerAPI}
                    customeriframeorapi={props.customeriframeorapi}
                />
            ) : (
                ""
            )}
            {tab === 1 ? (
                <div className="col-12 pt-3">
                    <OrderHistoryDetail
                        userinfo={props.userinfo}
                        language={props.language}
                    />
                </div>
            ) : (
                ""
            )}
            <SwalWarn
                show={swalopen.open}
                message={swalopen.message}
                onHide={() => setSwalOpen((prev) => ({ ...prev, open: false }))}
                onClose={() =>
                    setSwalOpen((prev) => ({ ...prev, open: false }))
                }
                responseOnOk={swalopen.okFunction}
            />
        </div>
    );
};
